import React, { useEffect } from "react";
import Modal from "react-modal";
import { useOncePopup } from "../../hooks/use-once-popup";
import "./home-forms-popup.scss";

const STORAGE_KEY = "pri_home_forms_popup_v1";
const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdwAcXwBMCgbsqz54sh6AwCeSd0DiaBVYKcwdlUV6hAHfhkjQ/viewform?embedded=true";

const HomeFormsPopup = () => {
  const { isOpen, dismiss } = useOncePopup(STORAGE_KEY, { delayMs: 1500 });

  useEffect(() => {
    if (typeof document !== "undefined") {
      Modal.setAppElement("#root");
    }
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={dismiss}
      contentLabel="Formulário"
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      ariaHideApp
      className="home-forms-popup"
      overlayClassName="home-forms-popup__overlay"
      bodyOpenClassName="home-forms-popup--open"
    >
      <div className="home-forms-popup__header">
        <h2 className="home-forms-popup__title">Participe</h2>
        <button
          type="button"
          className="home-forms-popup__close"
          onClick={dismiss}
          aria-label="Fechar formulário"
        >
          <i className="icon_close" aria-hidden="true" />
        </button>
      </div>
      <div className="home-forms-popup__body">
        <iframe
          src={FORM_URL}
          title="Formulário Google"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          loading="lazy"
        >
          Carregando…
        </iframe>
      </div>
    </Modal>
  );
};

export default HomeFormsPopup;
